import { environment } from '../config/environment';
import { useApiClient } from './api';

// BetaApp API types
export interface UserPlanData {
    userId: number;
    username: string;
    plan: PlanInfo;
}

export interface PlanInfo {
    status: number; // pro_status (0-6)
    transactionLimit: number | null; // null if unlimited
    currentTransactions: number;
    expiresAt: number; // Unix timestamp
    isUnlimited: boolean;
    isExpired: boolean;
    daysRemaining: number | null; // null if never expires
    taxReportsEnabled: boolean; // true if plan status > 1 AND within transaction limit
}

/**
 * Service for user plan data from BetaApp
 */
export const useUserPlanService = () => {
    const apiClient = useApiClient();

    /**
     * Get user plans from BetaApp (CoinTracking main app)
     * Returns global transaction limit data
     * @returns Promise with user plan data
     */
    const getUserPlans = async (): Promise<UserPlanData> => {
        try {
            const response = await apiClient.get(`${environment.expressApiUrl}/api/user/plans`);
            // Backend returns { success: true, data: { userId, username, plan } }
            // We need to extract the inner data object
            if (response.data.success && response.data.data) {
                return response.data.data;
            }
            return response.data;
        } catch (error) {
            console.error('Error fetching user plans:', error);
            throw error;
        }
    };

    return {
        getUserPlans,
    };
};
